import { useQueryIterations, useQueryStories } from '@/requests/queries/useQueryProject.ts'
import { getNow } from '@/utils/date.ts'

export const useGroupDoneStories = () => {
  const { stories } = useQueryStories('done')
  const { iterations } = useQueryIterations()

  const groupedStories = stories.reduce(
    (acc, story) => {
      const iterationNumber = story.iterationNumber ?? 1
      if (!acc[iterationNumber]) {
        acc[iterationNumber] = {
          stories: [],
          points: 0,
        } as GroupedStories
      }
      acc[iterationNumber].stories.push(story)
      acc[iterationNumber].points += story.estimate === -1 ? 0 : story.estimate
      return acc
    },
    {} as Record<number, GroupedStories>,
  )

  return iterations
    .filter((iteration) => iteration.finish < getNow())
    .map((iteration) => ({
      ...iteration,
      acceptedPoints: groupedStories[iteration.number]?.points ?? 0,
      stories: groupedStories[iteration.number]?.stories ?? [],
    }))
}
